// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2e5rb","select":"styles_select__3jfLQ"};